import { ProjectSupervisors } from '../../domain/project/projectSupervisors/ProjectSupervisors';
import { ProjectSupervisorsDTO } from '../../domain/project/projectSupervisors/ProjectSupervisorsDTO';
import { ProjectSupervisorsRepositoryDTO } from '../../domain/project/projectSupervisors/ProjectSupervisorsRepositoryDTO';
import { PlanType } from '../../domain/subscription/SubscriptionDTO';
import { ProjectSupervisorsStyleMapper } from './ProjectSupervisorsStyleMapper';

export class ProjectSupervisorsMapper {
  static toDomain(props: ProjectSupervisorsDTO): ProjectSupervisors {
    const { style } = props;

    return ProjectSupervisors.create({
      style: ProjectSupervisorsStyleMapper.toDomain(style),
    });
  }

  static toRepository(
    projectSupervisors: ProjectSupervisors,
    planType: Omit<PlanType, `monkey`>
  ): ProjectSupervisorsRepositoryDTO {
    const { style } = projectSupervisors;

    return {
      ...(planType === `kong` ? { style: ProjectSupervisorsStyleMapper.toRepository(style) } : {}),
    };
  }

  static toDTO(projectSupervisors: ProjectSupervisors): ProjectSupervisorsDTO {
    return {
      style: ProjectSupervisorsStyleMapper.toDTO(projectSupervisors.style),
    };
  }
}
